// import $ from "jquery";
import Swiper from 'swiper';
import { Navigation, Pagination, Autoplay } from 'swiper/modules';

class timelineSlider {
  constructor() {
    if ($(window).width() < 1025) {
      this.timeLine();
    }
  }

  timeLine() {
    // console.log("here we are");
    Swiper.use([Navigation, Pagination, Autoplay]);
    var Swipes = new Swiper('.timeline-slider', {
      slidesPerView: 1.5,
      spaceBetween: 16,
      grabCursor: true,
      centeredSlides: true,
      //loop: false,
      speed: 500,
      loop: false,
      allowTouchMove: true,
      // autoHeight: true,
      pagination: {
        el: '.timeline-slider .slider__pagination',
        clickable: true,
      },
      navigation: {
        nextEl: '.timeline-slider .slider__button-next',
        prevEl: '.timeline-slider .slider__button-prev',
      },
      breakpoints: {
        768: {
          slidesPerView: 3,
          spaceBetween: 16,
        },
      },
    });
  }

  resizeEvents() {
    $(window).on('resize', () => {
      this.timeLine();
    });
  }

  clickEvents() {}

  events() {
    this.clickEvents();
    this.resizeEvents();
  }
}

export default timelineSlider;
new timelineSlider();
